// src/components/About.js
import React from 'react';
import colors from '../colors';

function About() {
    return (
        <section id="about"  style={styles.about}>
            <p style={styles.text}>
                Wisemoji captures the essence of enlightened jokes.
            </p>
            <p style={styles.text}>
                We transform the profound sayings of Confucius, Buddha and other smart folks into viral memes, merging wisdom with the digital
                age's playful spirit.
            </p>
        </section>
    );
}

const styles = {
    about: {
        padding: '60px 20px',
        backgroundColor: colors.primary,
    },
    text: {
        fontSize: '1.2rem',
        color: colors.textLight,
        maxWidth: '800px',
        margin: '0 auto',
        lineHeight: '1.5',
    },
};

export default About;